// extracted by mini-css-extract-plugin
module.exports = {"instructor-list":"course-card-instructors_instructor-list__helor"};